import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    activeModal: null,
    showUpgradeModal: false,
    publishModal: {
      isActive: false,
      pageId: null,
      screenshotUrl: null,
      screenshotVersion: null,
      isScreenshotLoading: false,
    },
    templateModal: false,
    duplicatedToast: false,
    duplicateModal: false,
    welcomeModal: false,
    allSetModal: false,
    firstHits: { run: false, index: 0 },
    startConstructorHitsModal: false,
    endConstructorHitsModal: false,
    constructorHits: { run: false, index: 0 },
    previewModal: false,
    editImageModal: false,
    editImageModalSrc: null,
    editImageModalNodeId: null,
    removePageModal: false,
    subPageModal: false,
    addMenuItemModal: false,
    checkLinksModal: false,
    publishLimitModal: false,
    publishSubpagesLimitModal: false,
    subpagesLimitModal: false,
    blocksLimitModal: false,
    removeBrandingModal: false,
    animatedBgModal: false,
    selectionModal: false,
    selectedSectionId: null,
    globalFileManager: false
  },
  reducers: {
    openModal: (state, action) => {
      state.activeModal = action.payload.modalName;
    },
    closeModal: (state) => {
      state.activeModal = null;
    },
    setShowUpgradeModal: (state, action) => {
      state.showUpgradeModal = action.payload;
    },
    setPublishModal: (state, action) => {
      state.publishModal = {
        isActive: action.payload.isActive,
        pageId: action.payload.pageId,
        screenshotUrl: action.payload.screenshotUrl ?? null,
        screenshotVersion: action.payload.screenshotVersion ?? null,
        isScreenshotLoading: action.payload.isScreenshotLoading ?? false,
      };
    },
    setEditImageModal: (state, action) => {
      const payload = action.payload;

      if (typeof payload === "boolean") {
        state.editImageModal = payload;
        if (!payload) {
          state.editImageModalSrc = null;
          state.editImageModalNodeId = null;
        }
        return;
      }

      state.editImageModal = payload.show;
      if (payload.src !== undefined) {
        state.editImageModalSrc = payload.src;
      }
      if (payload.nodeId !== undefined) {
        state.editImageModalNodeId = payload.nodeId;
      }
      if (!payload.show) {
        state.editImageModalSrc = null;
        state.editImageModalNodeId = null;
      }
    },
    setTemplateModal: (state, action) => {
      state.templateModal = action.payload;
    },
    setDuplicatedToast: (state, action) => {
      state.duplicatedToast = action.payload;
    },
    setDuplicateModal: (state, action) => {
      state.duplicateModal = action.payload;
    },
    setWelcomeModal: (state, action) => {
      state.welcomeModal = action.payload;
    },
    setAllSetModal: (state, action) => {
      state.allSetModal = action.payload;
    },
    setFirstHitsRun: (state, action) => {
      state.firstHits = { ...state.firstHits, run: action.payload.run };
    },
    setFirstHitsIndex: (state, action) => {
      state.firstHits = { ...state.firstHits, index: action.payload.index };
    },
    setConstructorHitsRun: (state, action) => {
      state.constructorHits = {
        ...state.constructorHits,
        run: action.payload.run,
      };
    },
    setConstructorHitsIndex: (state, action) => {
      state.constructorHits = {
        ...state.constructorHits,
        index: action.payload.index,
      };
    },
    setPreviewModal: (state, action) => {
      state.previewModal = action.payload;
    },
    setStartConstructorHitsModal: (state, action) => {
      state.startConstructorHitsModal = action.payload;
    },
    setEndConstructorHitsModal: (state, action) => {
      state.endConstructorHitsModal = action.payload;
    },
    setRemovePageModal: (state, action) => {
      state.removePageModal = action.payload;
    },
    setSubPageModal: (state, action) => {
      state.subPageModal = action.payload;
    },
    setAddMenuItemModal: (state, action) => {
      state.addMenuItemModal = action.payload;
    },
    setCheckLinksModal: (state, action) => {
      state.checkLinksModal = action.payload;
    },
    setPublishLimitModal: (state, action) => {
      state.publishLimitModal = action.payload;
    },
    setPublishSubpagesLimitModal: (state, action) => {
      state.publishSubpagesLimitModal = action.payload;
    },
    setSubpagesLimitModal: (state, action) => {
      state.subpagesLimitModal = action.payload;
    },
    setBlocksLimitModal: (state, action) => {
      state.blocksLimitModal = action.payload;
    },
    setRemoveBrandingModal: (state, action) => {
      state.removeBrandingModal = action.payload;
    },
    setAnimatedBgModal: (state, action) => {
      state.animatedBgModal = action.payload;
    },
    setSelectionModal: (state, action) => {
      state.selectionModal = action.payload;
    },
    setSelectedSectionId: (state, action) => {
      state.selectedSectionId = action.payload;
    },
    setShowGlobalFileManager: (state, action) => {
      state.globalFileManager = action.payload;
    },
  },
});

export const {
  openModal,
  closeModal,
  setShowUpgradeModal,
  setPublishModal,
  setTemplateModal,
  setDuplicatedToast,
  setDuplicateModal,
  setWelcomeModal,
  setAllSetModal,
  setFirstHitsRun,
  setFirstHitsIndex,
  setPreviewModal,
  setConstructorHitsIndex,
  setConstructorHitsRun,
  setStartConstructorHitsModal,
  setEndConstructorHitsModal,
  setEditImageModal,
  setRemovePageModal,
  setSubPageModal,
  setAddMenuItemModal,
  setCheckLinksModal,
  setPublishLimitModal,
  setPublishSubpagesLimitModal,
  setSubpagesLimitModal,
  setBlocksLimitModal,
  setRemoveBrandingModal,
  setAnimatedBgModal,
  setSelectionModal,
  setSelectedSectionId,
  setShowGlobalFileManager
} = modalSlice.actions;
export default modalSlice.reducer;
